import { flags } from './properties';

export default function() {
    return new Promise(function(resolve, reject) {
        setTimeout(() => {
            flags.push({
                "personaFrm": true,
                "personaDsp": true
            });
            
            resolve();
        }, 10);
    });
}


// WEBPACK FOOTER //
// ./src/app-flags.js